/*
 * AddToCart for Shopify
 * Written for the FrontSystems store.
 *
 * Functions will be commented as we go.
 *
 */


$(document).ready(function() {

function updateShoppingCart(){
	$.ajax({
		type: 'GET',
		url: 'cart.js',
		async: false,
		cache: false,
		dataType: 'json',
		success:function(data){
			$("#cartCountProducts").text("(" + data.item_count + ")");
				$("#handlekurvMenu").animate({backgroundColor: '#6dc92f'}, 250, function(){
						$("#handlekurvMenu").animate({backgroundColor: '#fff'}, 250);
				});
		}
	})
	$(".btnWorking").removeClass("btnWorking");
}

$(".buyNowBtn").click(function(){
	var productId = $(this).data('id');
	$(this).addClass("btnWorking");
	$.ajax({
		type: 'POST',
		url: 'cart/add.js',
		async: false,
		cache: false,
		data: 'quantity=1&id=' + productId,
		dataType: 'json',
		error: addToCartError,
		success: addToCartSuccess
	});

});


function addToCartError(jqXHR, textStatus, errorThrown){
	
	if(jqXHR.status == 422) {
		$("#soldOutMessage").fadeIn(200);
	}
}

function addToCartSuccess(jqXHR, textStatus, errorThrown) {
	if(textStatus == "success") {
		console.log("Varen ble lagt til i handlekurven");
		updateShoppingCart();
	}
	
	else {
		console.log("En ukjent feil har oppstått. Forsøk på nytt");
	}
}



$(".gallery").click(function(e){
	return false;
});

$(".product-photo-thumb img").hover(function(){
	var full = $(this).data('fullsize');
	$(".featuredImg").attr('src', full);
	console.log(full);
})


$(".soldOutMsgClose").click(function(){
	$(this).parent().fadeOut();
})



	
	
	


	
function addToCart(id, qty){

	qty = typeof qty !== 'undefined' ? qty : 1;



	$.ajax({
		type: 'POST',
		url: 'cart/add.js',
		async: false,
		cache: false,
		data: 'quantity=' + qty+ '&id=' + id,
		dataType: 'json',
		error: cartResponse,
		success: cartResponse
	});
	
}

function changeCartItem(id, qty){

	$.ajax({
		type: 'POST',
		url: 'cart/change.js',
		async: false,
		cache: false,
		data: 'quantity=' + qty+ '&id=' + id,
		dataType: 'json',
		error: cartResponse,
		success: function(jqXHR, textStatus, errorThrown){
			
			cartUpdateResponse(jqXHR, textStatus, errorThrown, id, qty);
			
			
		}
	});
	
}

// Some weird shit might happen when we update.
function cartUpdateResponse(jqXHR, textStatus, errorThrown, productId, desiredQty){
	
	// Find the current line in the response
	
	console.log(desiredQty);
	
	$.each(jqXHR.items, function(index, value){
		if(value.id == productId){
			
			if(value.quantity != desiredQty){
				$("#soldOutMessageCart .messageData").html("<strong>Utslogt! </strong> Vi har ikke nok av varen du spurte etter, men du kan få de "+ value.quantity +" siste!");
				$("#soldOutMessageCart").fadeIn();
			}
			
		}
	});
	console.log("DONE");
	
	/* TO DO: OPPDATER TOTALPRISEN */
	
}



//addToCart(621941037, 1);


/* 
 * CART RESPONSE CODE:
 *
 * This function handles all the responses when trying to add something to the cart.
 * If the status code success is beeing sent, everything should be jolly fine. Else, you could 
 * implement other HTTP codes to catch.
 * 
*/

function cartResponse(jqXHR, textStatus, errorThrown) {

	if(textStatus == "success"){
		console.log("Seems to be working buddy");
		console.log(jqXHR);	
	}
	
	else {
		console.log(jqXHR);	
		// Sold out
		if(jqXHR.status == 422){
			console.log("This item seems to be sold out. Wat.");
		}
		
		// Anything else
		else {
			console.log("An unknown error occured.");
		}
		
	}
	
}


/* TO DO: FIND OUT IF ITS SOLD OUT */

var timer;
	$(".qty").change(function(){
		clearTimeout(timer);
		var id = $(this).data("elementid");
		var qty = $(this).val();
		
		// Wait a few ms to make sure user is done hitting that button (HTML5 enables up and down in number fields).
		 timer = setTimeout(function () {
		       changeCartItem(id, qty);
		    }, 500);
	});


});